export enum NotificationActionEnum {

  COMMENT = 'COMMENT',
  DELETE = 'DELETE',
  CREATE = 'CREATE',
  CHANGE = 'CHANGE',
  TASK_MANAGER = 'TASK_MANAGER',
  TASK_CLOSE = 'TASK_CLOSE',
  TASK_CANCEL = 'TASK_CANCEL',
  TASK_DELEGATE = 'TASK_DELEGATE',
  TASK_ACCEPT = 'TASK_ACCEPT',
  TASK_DISAGREE = 'TASK_DISAGREE',
  TASK_AGREE = 'TASK_AGREE',
  TASK_AUDIT = 'TASK_AUDIT',
  TASK_ADD_AGREEMENT = 'TASK_ADD_AGREEMENT',
  TASK_DEL_AGREEMENT = 'TASK_DEL_AGREEMENT',
  TASK_PUBLIC_COMMENT = 'TASK_PUBLIC_COMMENT',
  TASK_DEADLINE = 'TASK_DEADLINE',
  TASK_CHANGE_DEADLINE = 'TASK_CHANGE_DEADLINE',
  CLIENT_ADD_MANAGER = 'CLIENT_ADD_MANAGER',
  CLIENT_DEL_MANAGER = 'CLIENT_DEL_MANAGER',
  CONTRACT_EXPIRE = 'CONTRACT_EXPIRE',
  CONTRACT_SERVICE_EXPIRE = 'CONTRACT_SERVICE_EXPIRE',
  // USER_BLOCK = 'USER_BLOCK',
  // INTEGRATION_IMPORT = 'INTEGRATION_IMPORT',
  // INTEGRATION_EXPORT = 'INTEGRATION_EXPORT',
  // SYSTEM_UPDATE = 'SYSTEM_UPDATE',
  UPDATE_TASK_STEP = 'UPDATE_TASK_STEP',
  OFD_DATA_MISSING = 'OFD_DATA_MISSING',
  OFD_REVENUE_LOSS = 'OFD_REVENUE_LOSS',
  OFD_REVENUE_EXPORT_STARTED = 'OFD_REVENUE_EXPORT_STARTED',
  OFD_REVENUE_EXPORT_COMPLETED = 'OFD_REVENUE_EXPORT_COMPLETED',
  OFD_REVENUE_EXPORT_FAILED = 'OFD_REVENUE_EXPORT_FAILED',
}
